// React
import { useHistory } from 'react-router-dom';
import React, { useCallback, useState } from 'react';

// Components
import { notifySuccess, notifyError } from '../../../../components/notify';

// Yup & Formik
import * as Yup from 'yup';
import { useFormik } from 'formik';

// View
import { ViewChangeMonthlyPaymentList } from './view';

// Helpers & Utils
import { useLoading } from '../../../../hook/useLoading';
import { APIClient } from '../../../../helpers/api_helper';
import { columnsProposals } from '../../commom/columns/ColumnsListChangeMonthlyPayment';

const AssociatesScreen = () => {
  const [proposals, setProposals] = useState(null);
  const [totalPrice, setTotalPrice] = useState(0);
  const [selectedRows, setSelectedRows] = useState([]);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [isModalChangeOrg, setIsModalChangeOrg] = useState(false);

  const api = new APIClient();
  const history = useHistory();
  const { toggleLoading } = useLoading();

  const toggleModalChangeOrg = () => {
    setIsModalChangeOrg((prevState) => !prevState);
  };

  const handleSubmitChangeOrg = (organizationId, selectedRows) => {
    let body = {
      new_organization_id: organizationId,
      selected: selectedRows,
    };

    api
      .create('/proposal-upgrade/process', body)
      .then((res) => {
        notifySuccess(res.message || 'Valores atualizados com sucesso');
        setIsModalChangeOrg(false);
        validationSearch.resetForm();
        setProposals(null);
      })
      .catch((error) => {
        notifyError(error.response.data.message);
      });
  };

  const handleSubmit = (
    newValue,
    newPlan,
    calculation,
    effectiveDate,
    selectedRows
  ) => {
    let body = {
      new_plan_id: newPlan,
      new_value: newValue,
      commission_calc_base: calculation,
      effective_date: effectiveDate || null,
      selected: selectedRows,
    };

    api
      .create('/proposal-upgrade/process', body)
      .then((res) => {
        notifySuccess(res.message || 'Valores atualizados com sucesso');
        setModalIsOpen(false);
        validationSearch.resetForm();
        setProposals(null);
      })
      .catch((error) => {
        notifyError(error.response.data.message);
      });
  };

  const handleEdit = (values) => {
    const { hashid } = values;

    history.push(`/associados/edit/${hashid}`);
  };

  const calculateTotalPrice = (selectedRegisters) => {
    const sum = selectedRegisters.reduce((acc, row) => {
      const priceValue = parseFloat(row.price.replace(',', '.'));
      return acc + priceValue;
    }, 0);
    setTotalPrice(sum);
  };

  const handleChangeSelectedRows = ({ selectedRows }) => {
    const hashIds = selectedRows.map((row) => {
      return row.hashid;
    });
    setSelectedRows(hashIds);
    calculateTotalPrice(selectedRows);
  };

  const getList = useCallback(
    (plan_category_id, plan_id, organization_id, start_value, end_value) => {
      toggleLoading();

      const values = {
        plan_category_id: plan_category_id || null,
        plan_id: plan_id || null,
        organization_id: organization_id || null,
        start_value: start_value || 0,
        end_value: end_value || 0,
      };

      api
        .create('proposal-upgrade/search', values)
        .then((res) => {
          setProposals(res);
          toggleLoading();
        })
        .catch(() => {
          toggleLoading();
        });
    },
    []
  );

  const validationSearch = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      categoryPlan: null,
      plan: null,
      organization: null,
      firstValueOfMonthlyPayment: null,
      secondValueOfMonthlyPayment: null,
    },
    validationSchema: Yup.object({
      categoryPlan: Yup.object()
        .shape({
          label: Yup.string().required(),
          value: Yup.string().required(),
        })
        .required('Selecione uma categoria'),
      plan: Yup.object()
        .shape({
          label: Yup.string().required(),
          value: Yup.string().required(),
        })
        .required('Selecione um plano'),
      organization: Yup.object()
        .shape({
          label: Yup.string().nullable(),
          value: Yup.string().nullable(),
        })
        .nullable(),
      firstValueOfMonthlyPayment: Yup.string().nullable(),
      secondValueOfMonthlyPayment: Yup.string().nullable(),
    }),
    onSubmit: (values) => {
      handleSearch(values);
    },
  });

  const handleSearch = async (event) => {
    getList(
      event.categoryPlan?.value,
      event.plan?.value,
      event.organization?.value,
      event.firstValueOfMonthlyPayment,
      event.secondValueOfMonthlyPayment
    );
  };

  return (
    <ViewChangeMonthlyPaymentList
      // data
      proposals={proposals}
      selectedRows={selectedRows}
      planSelected={validationSearch?.values?.plan}
      categoryPlanSelected={validationSearch.values?.categoryPlan}
      // helpers
      isOpen={modalIsOpen}
      handleEdit={handleEdit}
      totalPrice={totalPrice}
      columns={columnsProposals}
      handleSearch={handleSearch}
      validation={validationSearch}
      reset={() => setProposals(null)}
      isModalChangeOrg={isModalChangeOrg}
      toggleModalChangeOrg={toggleModalChangeOrg}
      handleChangeSelectedRows={handleChangeSelectedRows}
      toggle={() => setModalIsOpen((prevState) => !prevState)}
      handleSubmitEditValue={(
        value,
        plan,
        calculation,
        effectiveDate,
        selectedRows
      ) => handleSubmit(value, plan, calculation, effectiveDate, selectedRows)}
      handleSubmitOrg={(organizationId) => {
        handleSubmitChangeOrg(organizationId, selectedRows);
      }}
    />
  );
};

export default AssociatesScreen;
